module.exports = __webpack_public_path__ + "static/media/checkbox.335e3e1b.svg";